import React, { ChangeEvent, FC, useState } from 'react';
import { Button, Dialog, DialogActions, FormControl, Grid, MenuItem } from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import { useCommonStyles } from 'src/styles';
import { CustomDialogTitle, SelectControl } from 'src/components';
import { useStyles } from './styles';

export interface Props {
  open: boolean;
  selected: string;
  translation: any;
  onClose: () => void;
  applyFilter: (isDaily: boolean) => void;
}

export const FiltersDialog: FC<Props> = ({ open, selected, translation, onClose, applyFilter }) => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const [period, setPeriod] = useState<string>(selected);

  const applyNewFilter = () => {
    applyFilter(period === 'Daily');
  };

  const clearFilter = () => {
    applyFilter(true);
  };

  const handleClose = () => {
    onClose();
  };

  const onPeriodChange = (event: ChangeEvent<{ value: any }>) => {
    const period = event.target.value;
    setPeriod(period);
  };

  return (
    <Dialog onClose={handleClose} open={open} classes={{ paper: classes.dialog }}>
      <CustomDialogTitle title={translation.filters} onClose={() => onClose()} />
      <Grid container direction="column">
        <Grid item>
          <p className={commonClasses.formControlTitle}>{translation.text_841}</p>
          <FormControl variant="outlined" className={commonClasses.formControl}>
            <SelectControl value={period} onChange={onPeriodChange} minWidth={97}>
              <MenuItem className={commonClasses.optionSelector} value="Daily">
                {translation.text_6421}
              </MenuItem>
              <MenuItem className={commonClasses.optionSelector} style={{ width: 'inherit' }} value="Monthly">
                {translation.text_6422}
              </MenuItem>
            </SelectControl>
          </FormControl>
        </Grid>
      </Grid>
      <DialogActions className={commonClasses.dialogAction}>
        <Button onClick={applyNewFilter} fullWidth startIcon={<Check />} className={commonClasses.activeDialogBtn}>
          {translation.text_65}
        </Button>
        <Button onClick={clearFilter} fullWidth startIcon={<Close />} className={commonClasses.cancelDialogBtn}>
          {translation.clearAll}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
